import { isValidTelUrl } from './is-valid-te-url';
import { linkify } from './linkify/linkify';

export const normalizeHref = (value: string): string | undefined => {
  if (isValidTelUrl(value)) {
    return value;
  }
  const [urlValue, anchor] = value.split('#');
  const normalizedUrl = urlValue && linkify.match(urlValue) && linkify.match(urlValue)?.[0]?.url;

  if (normalizedUrl === null) {
    return undefined;
  }

  return anchor ? `${normalizedUrl}#${anchor}` : normalizedUrl;
};
